import type { Appointment } from '../utils/appointmentManager';

/** Human-readable label for a payment method id stored on appointment.paymentData. */
export function formatBookingPaymentMethod(method?: string | null): string {
  if (!method) return 'Card';
  const m = String(method).toLowerCase();
  const labels: Record<string, string> = {
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    credit_card: 'Card',
    venmo: 'Venmo',
    pay_later: 'Pay at visit',
  };
  return labels[m] || String(method).replace(/_/g, ' ');
}

/** Customer prepaid when booking (saved from one-click checkout). */
export function isBookingPrepaid(appointment: Pick<Appointment, 'paymentData'>): boolean {
  return appointment.paymentData?.status === 'completed';
}

/**
 * Customer chose to pay the business directly via off-platform PayPal
 * (no API credentials connected, so BookAPT can't verify the payment) and the
 * booking was still confirmed so it isn't lost — merchant needs to check
 * their own PayPal account and confirm the payment came through.
 */
export function isBookingAwaitingPaymentConfirmation(
  appointment: Pick<Appointment, 'paymentData'>,
): boolean {
  return (
    appointment.paymentData?.paymentMethod === 'paypal' &&
    appointment.paymentData?.status !== 'completed'
  );
}
